/** Persist textarea scroll position while reading an item in the full-screen editor. */

const STORAGE_KEY = 'dailylife.itemReadingScroll.v1';

type ScrollStore = Record<string, number>;

function readStore(): ScrollStore {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object') return {};
    const out: ScrollStore = {};
    for (const [key, value] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
        out[key] = value;
      }
    }
    return out;
  } catch {
    return {};
  }
}

function writeStore(store: ScrollStore): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    /* ignore quota / private mode */
  }
}

export function readItemReadingScroll(key: string): number | null {
  const scrollTop = readStore()[key];
  return typeof scrollTop === 'number' ? scrollTop : null;
}

export function writeItemReadingScroll(key: string, scrollTop: number): void {
  if (!Number.isFinite(scrollTop) || scrollTop < 0) return;
  const store = readStore();
  store[key] = Math.round(scrollTop);
  writeStore(store);
}

export function clearItemReadingScroll(key: string): void {
  const store = readStore();
  if (!(key in store)) return;
  delete store[key];
  writeStore(store);
}
